import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  photoLoaded: false,
  photos: [], // Formally tracking the array in Redux
  photoById: {},
  index: 0,
};

const individualRating = createSlice({
  name: "individualRating",
  initialState,
  reducers: {
    loadPhotosRandom: (state, action) => {
      state.photoLoaded = true;
      state.photos = action.payload.photos;
      state.index = 0;
      
      const photoById = {};
      action.payload.photos.forEach((photo) => {
        photoById[photo["photo_id"]] = photo;
      });
      state.photoById = photoById;
    },
    setCurrentIndex: (state, action) => {
      state.index = action.payload.currentIndex;
    },
    updateCurrentPhoto: (state, action) => {
      const { photo_id, updates } = action.payload;

      // Check if the photo exists in state.photoById
      if (state.photoById[photo_id]) {
        // Create a shallow copy of the current photo and apply updates
        state.photoById[photo_id] = {
          ...state.photoById[photo_id],
          ...updates,
        };
      }
    },
    removePhoto: (state, action) => {
      const indexToRemove = action.payload.index;
      state.photos = state.photos.filter((_, i) => i !== indexToRemove);
      
      // Prevent index out of bounds if the last photo was removed
      if (state.index >= state.photos.length) {
        state.index = 0;
      }
    },
    resetRandomPhotos: (state) => {
      state.photoById = {};
      state.photos = [];
      state.photoLoaded = false;
      state.index = 0;
    },
  },
});

export const {
  loadPhotosRandom,
  resetRandomPhotos,
  setCurrentIndex,
  updateCurrentPhoto,
  removePhoto,
} = individualRating.actions;

export default individualRating.reducer;